import { HOTEL } from "@/data/site";
import { Phone, Navigation, CalendarCheck, ArrowUpRight } from "lucide-react";
import { trackCta } from "@/lib/analytics";

export const BookDirect = ({ className = "", label = "Book Direct", testid = "book-direct-cta" }) => (
  <a
    href={HOTEL.bookUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    onClick={() => trackCta("book")}
    className={`group inline-flex items-center gap-2 bg-brand-yellow px-6 py-3 font-heading font-black uppercase tracking-tight text-black transition-colors duration-300 hover:bg-brand-red hover:text-white ${className}`}
  >
    {label}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </a>
);

export const CallBtn = ({ className = "", testid = "call-cta", onDark = false }) => (
  <a
    href={`tel:${HOTEL.phone}`}
    data-testid={testid}
    onClick={() => trackCta("call")}
    className={`group inline-flex items-center gap-2 border px-6 py-3 font-heading font-black uppercase tracking-tight transition-colors duration-300 ${
      onDark
        ? "border-white/40 text-white hover:border-brand-yellow hover:text-brand-yellow"
        : "border-charcoal/25 text-charcoal hover:border-brand-red hover:text-brand-red"
    } ${className}`}
  >
    <Phone className="h-4 w-4" />
    Call Now
  </a>
);

export const DirectionsBtn = ({ className = "", testid = "directions-cta", onDark = false }) => (
  <a
    href={HOTEL.directionsUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    onClick={() => trackCta("directions")}
    className={`group inline-flex items-center gap-2 border px-6 py-3 font-heading font-black uppercase tracking-tight transition-colors duration-300 ${
      onDark
        ? "border-white/40 text-white hover:border-brand-yellow hover:text-brand-yellow"
        : "border-charcoal/25 text-charcoal hover:border-brand-red hover:text-brand-red"
    } ${className}`}
  >
    <Navigation className="h-4 w-4" />
    Directions
  </a>
);

export const CheckAvailBtn = ({ className = "", testid = "check-availability-cta" }) => (
  <a
    href={HOTEL.bookUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    onClick={() => trackCta("check_availability")}
    className={`group inline-flex items-center gap-2 bg-brand-red px-6 py-3 font-heading font-black uppercase tracking-tight text-white transition-colors duration-300 hover:bg-brand-yellow hover:text-black ${className}`}
  >
    <CalendarCheck className="h-4 w-4" />
    Check Availability
  </a>
);

export const CtaRow = ({ className = "", onDark = false }) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`}>
    <BookDirect />
    <CallBtn onDark={onDark} />
    <DirectionsBtn onDark={onDark} />
  </div>
);
